<template>
  <div class="account">
    <GlobalInfoBar title="退保列表" />
    <GlobalChunk :padding="[20, 20, 20, 20]">
      <GlobalForm :init-data="initData" :form-rules="formRules" :form-item-list="formItemList" :inline="true" round
        @handleConfirm="query" confirmBtnName="查询" :label-width="120">
        <el-form-item class="el_from" label="IMEI:" slot="imei" style="margin:0">
          <el-input v-model="imei" clearable placeholder="请输入IMEI查询"></el-input>
        </el-form-item>
        <el-form-item class="el_from" label="联系电话:" slot="phone" style="margin:0">
          <el-input v-model="phone" clearable placeholder="请输入联系电话查询"></el-input>
        </el-form-item>
        <!-- <div slot="AddSlot">
          <el-button type="primary" size="mini" @click="tableExport">列表导出</el-button>
        </div> -->
      </GlobalForm>

      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :currentPage="curPage"
        :total="totalElements" @handleCurrentChange="currentChange">
        <el-table-column label="操作" slot="operation" align="center"  fixed="right">
          <template slot-scope="{ row }">
            <el-button type="danger" size="mini" @click="surrenderHandle(row)">退保</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
  </div>
</template>

<script>
import environments from '../../config/url'
import api from '@/utils/request'
import { perClaimRemark } from "../../utils/request";
export default {
  name: "account",
  data() {
    return {
      initData: {},
      formRules: {},
      formItemList: [
        { slotName: "imei" },
        { slotName: "phone" },
        {
          key: "entryTime",
          type: "daterange",
          labelName: "时间:",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
        },
      ],
      imei: '',
      phone: '',
      beg_time: '',
      end_time: '',
      tableColumns: [
        { label: "迪信通id编码", prop: "policyId" },
        { label: "产品编码", prop: "productCode" },
        { label: "手机号", prop: "mobilePhone" },
        { label: "串码", prop: "imei" },
        { label: "退单时间", prop: "surrenderDate" },
        { label: "订单生成时间", prop: "addTime" },
        { slotName: 'operation' },
      ],
      tableData: [],
      curPage: 1,
      totalElements: 0,
      pageSize: 10,
      remarkDialog: {
        isShow: false,
        type: '',
        text: '',
        row: null
      },
      searchParams: null
    }
  },
  created() {
    this.getList()
  },
  mounted() {
  },
  methods: {
    tableExport() {
      console.log(environments[process.env.VUE_APP_BASE_URL].baseURL);
      const url = `${environments[process.env.VUE_APP_BASE_URL].baseURL}/Vivoaccept/acceptList?download=1&imei=${this.imei}&phone=${this.phone}&beg_time=${this.beg_time}&end_time=${this.end_time}` // 下载文件的url       
      const link = document.createElement('a')
      link.href = url
      link.download = '承保单列表.xls' // 下载文件的名称
      link.click()
    },
    query(data, cd) {
      cd();
      console.log(data, '11111111');
      if (data) {
        if (data.entryTime === null) {
          (this.beg_time = ""), (this.end_time = "");
        } else {
          this.beg_time = (data.entryTime && data.entryTime[0]) || "";
          this.end_time = (data.entryTime && data.entryTime[1]) || "";
        }
      } else {
        (this.beg_time = ""), (this.end_time = "");
      }
      this.curPage = 1
      this.getList()
    },
    currentChange(page) {
      this.curPage = page
      this.getList()
    },
    getList() {
      let params = {
        page: this.curPage,
        limit: this.pageSize,
        imei: this.imei,
        phone: this.phone,
        beg_time: this.beg_time,
        end_time: this.end_time
      }
      this.searchParams = params
      api.dexinSurrenderList(params).then(res => {
        this.tableData = res.data
        this.totalElements = res.count || 0
      })
    },
    surrenderHandle(row) {
      this.$alert('是否确定退保', '操作提示', {
        confirmButtonText: '确定',
        callback: action => {

          if (action == 'confirm') {
            const { policyId } = row
            api.dexinSurrenderHandle({ policyId }).then(res => {
              this.$message.success(res.msg)
            })
          }

        }
      });

    },
  }
}
</script>

<style scoped lang="scss">
.account {
  /deep/ .el-form-item__label {
    width: 80px !important;
  }
}
</style>
